// The Fluent Bit relay config a customer pastes onto a host inside their
// network. Firewalls speak syslog, not HTTPS, so something on the LAN has to
// bridge the two — this is that bridge, rendered with the source's own key.

export const SYSLOG_VENDOR_LABELS = {
  paloalto: "Palo Alto Networks",
  fortinet: "Fortinet FortiGate",
  sonicwall: "SonicWall",
  cisco: "Cisco ASA / FTD",
  sophos: "Sophos XG / XGS",
} as const;

/** Unprivileged port — binding 514 would require running the relay as root. */
export const RELAY_PORT = 5514;

/** Host portion of the ingestion URL, for Fluent Bit's `Host` key. */
function ingestionHost(url: string): string {
  try {
    return new URL(url).host;
  } catch {
    return url;
  }
}

/** Path portion, defaulting to `/ingest` when the URL carries none. */
function ingestionPath(url: string): string {
  try {
    const path = new URL(url).pathname;
    return path && path !== "/" ? path : "/ingest";
  } catch {
    return "/ingest";
  }
}

// ponytail: uncompressed. `compress gzip` keeps Content-Type: application/json
// while only setting Content-Encoding, and whether API Gateway then hands the
// Lambda base64 bytes or a lossily UTF-8-decoded string is not something we can
// verify from here. The endpoint agent has shipped gzip against the same API
// type for months and ingests fine, so this is likely safe — but the failure
// mode on this brand-new path is total (every batch 400s), so turn it on only
// after a real relay has been confirmed end-to-end against the live endpoint.
export function relayConfig(ingestionUrl: string, apiKey: string): string {
  // Parsers_File is load-bearing: the syslog input's default `syslog-rfc3164`
  // parser is defined in Fluent Bit's shipped parsers.conf, and without the
  // include the service refuses to start. The path is where the official
  // Linux packages put it.
  return `[SERVICE]
    Flush        5
    Log_Level    info
    Parsers_File /etc/fluent-bit/parsers.conf

[INPUT]
    Name      syslog
    Tag       firewall
    Mode      udp
    Listen    0.0.0.0
    Port      ${RELAY_PORT}
    Parser    syslog-rfc3164

[OUTPUT]
    Name       http
    Match      firewall
    Host       ${ingestionHost(ingestionUrl)}
    Port       443
    URI        ${ingestionPath(ingestionUrl)}
    Format     json
    tls        On
    tls.verify On
    Header     X-Api-Key ${apiKey}
    Retry_Limit 5
`;
}
